<template>
  <el-dialog title="取消订单" :visible.sync="dialogTableVisible" width="25%" :append-to-body="true" :close-on-click-modal="false">
    <template slot="title">
      <div class="title">取消订单</div>
    </template>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="取消原因">
        <el-input type="textarea" maxlength="100" placeholder="请输入订单取消的原因" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <el-form-item label-width="150px">
        <el-button @click="resetForm('ruleForm')">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        dialogTableVisible: false,
        cancelIndet: true,
        ruleForm: {},
        rules: {}
      };
    },
    methods: {
      // 单选框事件
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$axios.post(this.$url.cancelOrder, {
              id: this.id,
              cancelReason: this.ruleForm.desc
            })
              .then(res => {
                console.log("我是取消订单", res);
                if (res.code === 0) {
                  this.$message.success("修改成功");
                  this.dialogTableVisible = false;
                  this.$emit("action", 'quxiao')
                }
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.dialogTableVisible = false;
        this.ruleForm = {};
        this.$forceUpdate();
      }

    }
  };
</script>

<style lang='less' scoped>
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(72, 72, 72, 1);
  }

  ::v-deep .el-dialog__body {
    padding-top: 10px;
  }

  ::v-deep .el-input__inner {
    width: 320px;
    height: 36px;
  }

  ::v-deep .el-textarea__inner {
    width: 320px;
    height: 96px;
  }
</style>
